<template>
  <div class="c-header-container">
      <div class="c-header-item">
          {{resource["userHeader.Name"]}}
      </div>
      <div class="c-header-item">
        {{resource["userHeader.Surname"]}}
    </div>
    <div class="c-header-item">
      {{resource["userHeader.Email"]}}
  </div>
  </div>
</template>

<style lang="scss" scoped>
.c-header-container{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 16px;
  border: 1px solid #E4E4E4;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background: #FFFFFF;
  .c-header-item{
    display: flex;
    width: 25%;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #1D1D1D;

    &:last-child{
      width: 50%;
    }
  }
}
</style>
<script>
export default {
  name: 'UserListHeader',
};
</script>
